module.exports = __webpack_public_path__ + "static/media/Card-Black.4828b2c0.png";